<template>
  <div>
    <div
      class="alert alert-calculation"
      role="alert"
    >{{this.$i18n.translate('Results')}}</div>
    <br>
    <!-- SHOW NUTRIENTS -->
    <template v-if="Nutrients[0]">
      <p>
        <b>{{this.$i18n.translate('RequiredNutrientAmount')}}:</b>
      </p>
      <div
        v-for="(nutrient,i) in Nutrients"
        :key="i"
      >
        <p class="text-muted">{{nutrient.nutrientName}}: {{nutrient.amountDisplay}}</p>
      </div>
      <hr>
      <br>
    </template>
    <!-- END NUTRIENTS -->

    <!-- START GENERAL RECOMMENDATION -->
    <template v-if="RecommendationsGeneral[0]">
      <div
        v-for="(recommend,i) in RecommendationsGeneral"
        :key="i"
      >
        <h4 class="border-ePetro-title-remark ePetro-subtitle-remark">{{recommend.title}}</h4>
        <br>
        <p class="text-muted">{{recommend.text}}</p>
        <br>
      </div>
    </template>

    <!-- START OSNOVNA GNOJIDBA -->
    <template v-if="FertilizerRecommendationsBasic[0]">
      <template>
        <h4 class="border-ePetro-title ePetro-subtitle">{{FertilizerRecommendationsBasic[0].fertilizationStage.name}}</h4>
        <br>
        <table class="table border">
          <thead class="text-center">
            <tr class="ePetro-table-row-thead">
              <th style="width: 50%" class="ePetro-table-th">{{this.$i18n.translate('RecommendedFertilizer')}}</th>
              <th style="width: 25%">{{this.$i18n.translate('QuantityPerHA')}}</th>
              <th style="width: 25%">{{this.$i18n.translate('TotalQuantity')}}</th>
            </tr>
          </thead>
          <tbody class="ePetro-table-row-tbody">
            <tr
              v-for="(fertilizer, index) in FertilizerRecommendationsBasic"
              :key="index + '-basic'"
            >
              <td class="ePetro-table-td">
                <div class="form-group col-md-12">
                  <select
                    class="form-control input-ePetro-select"
                    id="fertilizierBasic"
                    @change="osnovnaGnojidbaChange().prevent"
                    v-model.number="osnovnaGnojidbaFert"
                  >
                    <option
                      v-for="(fertilizerObject, index) in fertilizer.fertilizers"
                      :key="index"
                      :value="fertilizerObject.fertilizerId"
                    >{{fertilizerObject.fertilizerName}}</option>
                  </select>
                </div>
              </td>
              <template v-if="!loadIconResult">
                <td valign="middle" class="text-center">
                  <icon icon="spinner" pulse/>
                </td>
                <td valign="middle" class="text-center">
                  <icon icon="spinner" pulse/>
                </td>
              </template>
              <template v-else>
                <td valign="middle" class="text-center">{{fertilizer.amountPerSurfaceDisplay}}</td>
                <td valign="middle" class="text-center">{{fertilizer.totalAmountDisplay}}</td>
              </template>
            </tr>
          </tbody>
        </table>
        <template v-if="RecommendationsOsnovna[0] ">
          <h4 class="border-ePetro-title-remark ePetro-subtitle-remark">{{RecommendationsOsnovna[0].title}} {{this.$i18n.translate('Recommendation')}}</h4>
          <br>
          <p
            class="text-muted"
            v-for="(recommend, i) in RecommendationsOsnovna"
            :key="i + '-recomendationsOsn'"
          >{{recommend.text}}</p>
        </template>
        <br>
        <br>
      </template>
    </template>
    <!-- END OSNOVNA GNOJIDBA -->

    <!-- START PREDSJETVENA GNOJIDBA -->
    <template v-if="FertilizerRecommendationsInitial[0] || RecommendationsPredsjetvena[0]">
      <template v-if="FertilizerRecommendationsInitial[0]">
        <h4 class="border-ePetro-title ePetro-subtitle">{{FertilizerRecommendationsInitial[0].fertilizationStage.name}}</h4>
        <br>
        <table class="table border">
          <thead class="text-center">
            <tr class="ePetro-table-row-thead">
              <th style="width: 50%" class="ePetro-table-th">{{this.$i18n.translate('RecommendedFertilizer')}}</th>
              <th style="width: 25%">{{this.$i18n.translate('QuantityPerHA')}}</th>
              <th style="width: 25%">{{this.$i18n.translate('TotalQuantity')}}</th>
            </tr>
          </thead>
          <tbody class="ePetro-table-row-tbody">
            <tr
              v-for="(fertilizer, index) in FertilizerRecommendationsInitial"
              :key="index + '-initial'"
            >
              <td class="ePetro-table-td">
                <div class="form-group col-md-12">
                  <select
                    class="form-control input-ePetro-select"
                    @change="predsjetvenaGnojidbaChange().prevent"
                    id="fertilizierInitial"
                    v-model.number="predsjetvenaGnojidbaFert"
                  >
                    <option
                      v-for="(fertilizerObject, index) in fertilizer.fertilizers"
                      :key="index"
                      :value="fertilizerObject.fertilizerId"
                    >{{fertilizerObject.fertilizerName}}</option>
                  </select>
                </div>
              </td>
              <template v-if="!loadIconResult">
                <td valign="middle" class="text-center">
                  <icon icon="spinner" pulse/>
                </td>
                <td valign="middle" class="text-center">
                  <icon icon="spinner" pulse />
                </td>
              </template>
              <template v-else>
                <td valign="middle" class="text-center">{{fertilizer.amountPerSurfaceDisplay}}</td>
                <td valign="middle" class="text-center">{{fertilizer.totalAmountDisplay}}</td>
              </template>
            </tr>
          </tbody>
        </table>
      </template>
      <template v-if="RecommendationsPredsjetvena[0]">
        <h4 class="border-ePetro-title-remark ePetro-subtitle-remark">{{RecommendationsPredsjetvena[0].title}} {{this.$i18n.translate('Recommendation')}}</h4>
        <br>
        <p
          class="text-muted"
          v-for="(recommend, index) in RecommendationsPredsjetvena"
          :key="index + '-pred'"
        >{{recommend.text}}</p>
      </template>
      <br>
      <br>
    </template>
    <!-- END PREDSJETVENA GNOJIDBA -->

    <!-- START PRIHRANA U TLO  1-->
    <template v-if="FertilizerRecommendationsFertilization_1[0] || RecommendationsPrihrana_1[0]">
      <template v-if="FertilizerRecommendationsFertilization_1[0]">
        <h4 class="border-ePetro-title ePetro-subtitle">{{ PrihranaTitle ? this.$i18n.translate('Fertilization') : FertilizerRecommendationsFertilization_1[0].fertilizationStage.name }}</h4>
        <br>
        <table class="table border">
          <thead class="text-center">
            <tr class="ePetro-table-row-thead">
              <th style="width: 50%" class="ePetro-table-th">{{this.$i18n.translate('RecommendedFertilizer')}}</th>
              <th style="width: 25%">{{this.$i18n.translate('QuantityPerHA')}}</th>
              <th style="width: 25%">{{this.$i18n.translate('TotalQuantity')}}</th>
            </tr>
          </thead>
          <tbody class="ePetro-table-row-tbody">
            <tr
              v-for="(fertilizer, index) in FertilizerRecommendationsFertilization_1"
              :key="index"
            >
              <td class="ePetro-table-td">
                <div class="form-group col-md-12">
                  <select
                    class="form-control input-ePetro-select"
                    @change="onFertilizerChange_1().prevent"
                    id="recommendationsFertilization_1"
                    v-model.number="chosenFert_1"
                  >
                    <option
                      v-for="(fertilizerObject, index) in fertilizer.fertilizers"
                      :key="index"
                      :value="fertilizerObject.fertilizerId"
                    >{{fertilizerObject.fertilizerName}}</option>
                  </select>
                </div>
              </td>
              <template v-if="!loadIconResult">
                <td valign="middle" class="text-center">
                  <icon icon="spinner" pulse/>
                </td>
                <td valign="middle" class="text-center">
                  <icon icon="spinner" pulse/>
                </td>
              </template>
              <template v-else>
                <td valign="middle" class="text-center">{{fertilizer.amountPerSurfaceDisplay}}</td>
                <td valign="middle" class="text-center">{{fertilizer.totalAmountDisplay}}</td>
              </template>
            </tr>
          </tbody>
        </table>
      </template>
      <template v-if="RecommendationsPrihrana_1[0]">
        <h4 class="border-ePetro-title-remark ePetro-subtitle-remark">{{RecommendationsPrihrana_1[0].title}} {{this.$i18n.translate('Recommendation')}}</h4>
        <br>
        <p
          class="text-muted"
          v-for="(recommend, i) in RecommendationsPrihrana_1"
          :key="i + '-prih_1'"
        >{{recommend.text}}</p>
      </template>
      <br>
      <br>
    </template>
    <!-- END PRIHRANA U TLO 1 -->

    <!-- START PRIHRANA U TLO  2-->
    <template v-if="FertilizerRecommendationsFertilization_2[0] || RecommendationsPrihrana_2[0]">
      <template>
        <h4 class="border-ePetro-title ePetro-subtitle">{{ PrihranaTitle ? this.$i18n.translate('Fertilization') : FertilizerRecommendationsFertilization_2[0].fertilizationStage.name }}</h4>
        <br>
        <table class="table border">
          <thead class="text-center">
            <tr class="ePetro-table-row-thead">
              <th style="width: 50%" class="ePetro-table-th" >{{this.$i18n.translate('RecommendedFertilizer')}}</th>
              <th style="width: 25%">{{this.$i18n.translate('QuantityPerHA')}}</th>
              <th style="width: 25%">{{this.$i18n.translate('TotalQuantity')}}</th>
            </tr>
          </thead>
          <tbody class="ePetro-table-row-tbody">
            <tr
              v-for="(fertilizer, index) in FertilizerRecommendationsFertilization_2"
              :key="index +'-ferti2'"
            >
              <td class="ePetro-table-td">
                <div class="form-group col-md-12">
                  <select
                    class="form-control input-ePetro-select"
                    @change="onFertilizerChange_2()"
                    id="recommendationsFertilization_2"
                    v-model.number="chosenFert_2"
                  >
                    <option
                      v-for="(fertilizerObject, index) in fertilizer.fertilizers"
                      :key="index"
                      :value="fertilizerObject.fertilizerId"
                    >{{fertilizerObject.fertilizerName}}</option>
                  </select>
                </div>
              </td>
              <template v-if="!loadIconResult">
                <td valign="middle" class="text-center">
                  <icon icon="spinner" pulse/>
                </td>
                <td valign="middle" class="text-center">
                  <icon icon="spinner" pulse />
                </td>
              </template>
              <template v-else>
                <td valign="middle" class="text-center">{{fertilizer.amountPerSurfaceDisplay}}</td>
                <td valign="middle" class="text-center">{{fertilizer.totalAmountDisplay}}</td>
              </template>
            </tr>
          </tbody>
        </table>
      </template>
      <template v-if="RecommendationsPrihrana_2[0] ">
        <h4 class="border-ePetro-title-remark ePetro-subtitle-remark">{{RecommendationsPrihrana_2[0].title}} {{this.$i18n.translate('Recommendation')}}</h4>
        <br>
        <p
          class="text-muted"
          v-for="(recommend, i) in RecommendationsPrihrana_2"
          :key="i + '-prih_2'"
        >{{recommend.text}}</p>
      </template>
      <br>
      <br>
    </template>
    <!-- END PRIHRANA U TLO 2 -->

    <!-- START MELIORATIVNA -->
    <template v-if="FertilizerRecommendationsMeliorative[0]">
      <template>
        <h4 class="border-ePetro-title ePetro-subtitle">{{FertilizerRecommendationsMeliorative[0].fertilizationStage.name}}</h4>
        <br>
        <table class="table border">
          <thead class="text-center">
            <tr class="ePetro-table-row-thead">
              <th style="width: 50%" class="ePetro-table-th">{{this.$i18n.translate('RecommendedFertilizer')}}</th>
              <th style="width: 25%">{{this.$i18n.translate('QuantityPerHA')}}</th>
              <th style="width: 25%">{{this.$i18n.translate('TotalQuantity')}}</th>
            </tr>
          </thead>
          <tbody class="ePetro-table-row-tbody">
            <tr
              v-for="(fertilizer, index) in FertilizerRecommendationsMeliorative"
              :key="index +'-melio'"
            >
              <td class="ePetro-table-td">
                <div class="form-group col-md-12">
                  <select
                    class="form-control input-ePetro-select"
                    @change="onFertilizerChangeMelio()"
                    id="recommendationsFertilizationMelio"
                    v-model.number="chosenMelio"
                  >
                    <option
                      v-for="(fertilizerObject, index) in fertilizer.fertilizers"
                      :key="index"
                      :value="fertilizerObject.fertilizerId"
                    >{{fertilizerObject.fertilizerName}}</option>
                  </select>
                </div>
              </td>
              <template v-if="!loadIconResult">
                <td valign="middle" class="text-center">
                  <icon icon="spinner" pulse/>
                </td>
                <td valign="middle" class="text-center">
                  <icon icon="spinner" pulse />
                </td>
              </template>
              <template v-else>
                <td  valign="middle" class="text-center">{{fertilizer.amountPerSurfaceDisplay}}</td>
                <td valign="middle" class="text-center">{{fertilizer.totalAmountDisplay}}</td>
              </template>
            </tr>
          </tbody>
        </table>
      </template>
      <template v-if="RecommendationsMeliorativna[0] ">
        <h4 class="border-ePetro-title-remark ePetro-subtitle-remark">{{RecommendationsMeliorativna[0].title}} {{this.$i18n.translate('Recommendation')}}</h4>
        <br>
        <p
          class="text-muted"
          v-for="(recommend, i) in RecommendationsMeliorativna"
          :key="i + '-melio'"
        >{{recommend.text}}</p>
      </template>
      <br>
      <br>
    </template>
    <!-- END MELIORATIVNA -->
  </div>
</template>

<script>

import STAGES from '../fertilizationStages.js'
// Fertilization stages object table = fertilizationstages
// TO DO prepopulate objects from Db
// const stages = {
//   OSNOVNA: 1,
//   PREDSJETVENA: 2,
//   PRVA_PRIHRANA: 3,
//   DRUGA_PRIHRANA: 4,
//   MELIORATIVNA: 5,
//   GENERAL_NULL: null,
//   GENERAL_UNDEFINED: undefined
// };

export default {
  data () {
    return {
      nutrients: [],
      fertilizerRecommendations: [],
      recommendations: [],
      errorOnSubmit: null,

      // Flag for loading icon
      loadIconResult: true,

      // Select selectedFertilizerId
      osnovnaGnojidbaFert: null,
      predsjetvenaGnojidbaFert: null,
      chosenFert_1: null,
      chosenFert_2: null,
      chosenMelio: null,

      // Select fertilization id by stage 
      osnovnaGnojidbaFertStage: null,
      predsjetvenaGnojidbaFertStage: null,
      chosenFertStage_1: null,
      chosenFertStage_2: null,
      chosenMelioStage: null,

      // Vuex store getters
      get: this.$store.getters
    };
  },
  computed: {
    vuexCropID () {
      return this.get.cropID;
    },
    vuexCropStageID () {
      return this.get.cropStageId;
    },
    vuexYield () {
      return this.get.yield;
    },
    vuexYieldUnitId () {
      return this.get.yieldUnitId;
    },
    vuexSurface () {
      return this.get.surface;
    },
    vuexSurfaceUnitID () {
      return this.get.surfaceUnitId;
    },
    vuexK2O () {
      return this.get.k2O;
    },
    vuexP2O5 () {
      return this.get.p2O5;
    },
    vuexpH () {
      return this.get.ph;
    },
    vuexHumus () {
      return this.get.humus;
    },
    vuexSoilType () {
      return this.get.soilTypeId;
    },
    vuexSelectedFertilizersOnStages () {
      return this.get.selectedFertilizersOnStages;
    },
    Nutrients () {
      // // Get cropStageId 'Podizanje nasada'
      // let cropStageId = this.get.cropStageId

      // // Get nutrient values
      // let nutrientArray = this.get.nutrients;

      // // Check crop stage
      // if (cropStageId === 1) {
      //     // Return only P & K, filter out N nutrient
      //     return nutrientArray.filter(e => e.nutrientId === 2 || e.nutrientId === 3);
      // } else {
      //     return this.nutrients = this.get.nutrients;
      // }

      return this.nutrients = this.get.nutrients;

    },
    FertilizerRecommendationsBasic () {
      // Filter by Osnovna gnojidba
      return this.fertilizerRecommendations = this.get.fertilizerRecommendations.filter(x => x.fertilizationStage.id === STAGES.OSNOVNA);
    },
    FertilizerRecommendationsInitial () {
      // Filter by Predsjetvena gnojidba
      return this.fertilizerRecommendations = this.get.fertilizerRecommendations.filter(x => x.fertilizationStage.id === STAGES.PREDSJETVENA);
    },
    FertilizerRecommendationsFertilization_1 () {
      // Filter by Prihrana 1 
      return this.fertilizerRecommendations = this.get.fertilizerRecommendations.filter(x => x.fertilizationStage.id === STAGES.PRVA_PRIHRANA);
    },
    FertilizerRecommendationsFertilization_2 () {
      // Filter by Prihrana 2 u tlo
      return this.fertilizerRecommendations = this.get.fertilizerRecommendations.filter(x => x.fertilizationStage.id === STAGES.DRUGA_PRIHRANA);
    },
    FertilizerRecommendationsMeliorative () {
      // Filter by Meliorativna
      return this.fertilizerRecommendations = this.get.fertilizerRecommendations.filter(x => x.fertilizationStage.id === STAGES.MELIORATIVNA);
    },
    Recommendations () {
      // Get all recommendations
      return this.recommendations = this.get.recommendations;
    },
    RecommendationsOsnovna () {
      // Filter recommendations
      return this.recommendations = this.get.recommendations.filter(x => x.fertilizationStage !== STAGES.GENERAL_NULL && x.fertilizationStage.id === STAGES.OSNOVNA);
    },
    RecommendationsPrihrana_1 () {
      // Filter recommendations by Prihrana 1
      // let prihranaFirstFilter = this.get.recommendations.filter(x => x.fertilizationStage !== stages.GENERAL_NULL && x.fertilizationStage.id === stages.PRVA_PRIHRANA);

      // // If Fertilizer 1 and Fertilizer 2 exist then filter out message
      // if (this.FertilizerRecommendationsFertilization_1[0] && this.FertilizerRecommendationsFertilization_2[0]) {

      //     // Flag message 
      //     let prihranaFilterText = 'Dobivenu količinu gnojiva potrebno je raspodijeliti u nekoliko obroka.';

      //     // Filter out flaged message
      //     const arrayfilter = prihranaFirstFilter.filter(e => e.text !== prihranaFilterText);

      //     return this.recommendations = arrayfilter;

      // } else {
      //     return this.recommendations = prihranaFirstFilter;
      // }

      return this.recommendations = this.get.recommendations.filter(x => x.fertilizationStage !== STAGES.GENERAL_NULL && x.fertilizationStage.id === STAGES.PRVA_PRIHRANA);

    },
    RecommendationsPrihrana_2 () {
      // Filter recommendations by Prihrana 2
      return this.recommendations = this.get.recommendations.filter(x => x.fertilizationStage !== STAGES.GENERAL_NULL && x.fertilizationStage.id === STAGES.DRUGA_PRIHRANA);
    },
    RecommendationsPredsjetvena () {
      // Filter recommendations by Predsjetvena
      return this.recommendations = this.get.recommendations.filter(x => x.fertilizationStage !== STAGES.GENERAL_NULL && x.fertilizationStage.id === STAGES.PREDSJETVENA);

    },
    RecommendationsMeliorativna () {
      // Filter recommendations by Meliorativna
      return this.recommendations = this.get.recommendations.filter(x => x.fertilizationStage !== STAGES.GENERAL_NULL && x.fertilizationStage.id === STAGES.MELIORATIVNA);
    },
    RecommendationsGeneral () {
      // Filter recommendations by General
      // remove || filter for stages OSNOVNA, fix will be applied on API
      // return this.recommendations = this.get.recommendations.filter(x => x.fertilizationStage === stages.GENERAL_NULL || x.fertilizationStage === stages.GENERAL_UNDEFINED || x.fertilizationStage.id === stages.OSNOVNA);
      return this.recommendations = this.get.recommendations.filter(x => x.fertilizationStage === STAGES.GENERAL_NULL || x.fertilizationStage === STAGES.GENERAL_UNDEFINED);
    },
    PrihranaTitle () {

      // If there is only one Prihrana (instead of two, Prihrana 1 & Prihrana 2) then change title to Prihrana
      let prihrana_1 = this.FertilizerRecommendationsFertilization_1[0];
      let prihrana_2 = this.FertilizerRecommendationsFertilization_2[0];

      // Recomendations exists, return false
      if (prihrana_1 && prihrana_2) {
        return false;
      }
      return true;
    },
    ErrorOnSubmit () {
      return this.errorOnSubmit = this.get.errorSubmit;
    }
  },
  methods: {
    osnovnaGnojidbaChange: async function () {
      // Setting load icon to false
      this.loadIconResult = false;
      this.submitFormDataResults(this.osnovnaGnojidbaFertStage, this.osnovnaGnojidbaFert);
    },
    predsjetvenaGnojidbaChange: async function () {
      this.loadIconResult = false;
      this.submitFormDataResults(this.predsjetvenaGnojidbaFertStage, this.predsjetvenaGnojidbaFert);
    },
    onFertilizerChange_1: async function () {
      this.loadIconResult = false;
      this.submitFormDataResults(this.chosenFertStage_1, this.chosenFert_1);
    },
    onFertilizerChange_2: function () {
      this.loadIconResult = false;
      this.submitFormDataResults(this.chosenFertStage_2, this.chosenFert_2);
    },
    onFertilizerChangeMelio: function () {
      this.loadIconResult = false;
      this.submitFormDataResults(this.chosenMelioStage, this.chosenMelio);
    },
    submitFormDataResults: async function () {

      let fertArray = [];
      if (this.osnovnaGnojidbaFertStage !== null) {
        fertArray.push({
          fertilizationStageId: this.osnovnaGnojidbaFertStage,
          selectedFertilizerId: this.osnovnaGnojidbaFert
        });
      }
      if (this.predsjetvenaGnojidbaFertStage) {
        fertArray.push({
          fertilizationStageId: this.predsjetvenaGnojidbaFertStage,
          selectedFertilizerId: this.predsjetvenaGnojidbaFert
        });
      }
      if (this.chosenFertStage_1) {
        fertArray.push({
          fertilizationStageId: this.chosenFertStage_1,
          selectedFertilizerId: this.chosenFert_1
        });
      }
      if (this.chosenFertStage_2) {
        fertArray.push({
          fertilizationStageId: this.chosenFertStage_2,
          selectedFertilizerId: this.chosenFert_2
        });
      }
      if (this.chosenMelioStage) {
        fertArray.push({
          fertilizationStageId: this.chosenMelioStage,
          selectedFertilizerId: this.chosenMelio
        });
      }

      const formData = {
        CropId: this.vuexCropID,
        CropStageID: this.vuexCropStageID,
        Yield: this.vuexYield,
        YieldUnitId: this.vuexYieldUnitId,
        Surface: this.vuexSurface,
        SurfaceUnitId: this.vuexSurfaceUnitID,
        K2O: this.vuexK2O,
        P2O5: this.vuexP2O5,
        pH: this.vuexpH,
        Humus: this.vuexHumus,
        SoilTypeID: this.vuexSoilType,
        selectedFertilizersOnStages: fertArray

      };

      // console.log("POSTED RESULTS DATA!");
      // console.log(formData);

      await this.$http.post('Calculator', formData)
        .then(res => {

          // Response data
          const responseData = res.data.data;

          console.log("RESULTS SEND DATA");
          console.log(responseData);

          // Show results on post
          this.showResults = true;

          // Nutrients response
          const nutrients = responseData.nutrients;
          // FertilizerRecommendations response
          const fertilizerRecommendations = responseData.fertilizerRecommendations;
          // Recommendations response
          const recommendations = responseData.recommendations;

          // Set model data
          this.fertilizerRecommendations = fertilizerRecommendations;
          this.recommendations = recommendations;
          this.nutrients = nutrients;

          // console.log(fertilizerRecommendations);
          // console.log(recommendations)

          // Storing response data in Vuex
          this.$store.dispatch('UpdateNutrients', nutrients);
          this.$store.dispatch('UpdateRecommendations', recommendations);
          this.$store.dispatch('UpdateFertilizerRecommendations', fertilizerRecommendations);
          this.$store.dispatch('UpdateResponseData', responseData);

          // Change flag to true
          this.loadIconResult = true;
          this.$forceUpdate();

          // this.created();


        })
        .catch(error => {
          console.log(error);
          this.errorSubmit = true;
          this.showResults = false;
          this.$store.dispatch('UpdateErrorSubmit', this.errorSubmit);
        });
    }
  },
  created: function () {
    console.log(STAGES.OSNOVNA)
    if (this.FertilizerRecommendationsBasic[0]) {
      // Binding values of fertilization stage
      this.osnovnaGnojidbaFertStage = this.FertilizerRecommendationsBasic[0].fertilizationStage.id;
      // Binding values of fertilization id
      this.osnovnaGnojidbaFert = this.FertilizerRecommendationsBasic[0].selectedFertilizer.fertilizerId;
    }
    if (this.FertilizerRecommendationsInitial[0]) {
      this.predsjetvenaGnojidbaFertStage = this.FertilizerRecommendationsInitial[0].fertilizationStage.id;
      this.predsjetvenaGnojidbaFert = this.FertilizerRecommendationsInitial[0].selectedFertilizer.fertilizerId;
    }

    if (this.FertilizerRecommendationsFertilization_1[0]) {
      this.chosenFertStage_1 = this.FertilizerRecommendationsFertilization_1[0].fertilizationStage.id;
      this.chosenFert_1 = this.FertilizerRecommendationsFertilization_1[0].selectedFertilizer.fertilizerId;
    }

    if (this.FertilizerRecommendationsFertilization_2[0]) {
      this.chosenFertStage_2 = this.FertilizerRecommendationsFertilization_2[0].fertilizationStage.id;
      this.chosenFert_2 = this.FertilizerRecommendationsFertilization_2[0].selectedFertilizer.fertilizerId;
    }

    if (this.FertilizerRecommendationsMeliorative[0]) {
      this.chosenMelioStage = this.FertilizerRecommendationsMeliorative[0].fertilizationStage.id;
      this.chosenMelio = this.FertilizerRecommendationsMeliorative[0].selectedFertilizer.fertilizerId;
    }

  }

};

</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
